<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="contentArticleLabel.attributes"
          headline="Edit Article Label"
          :errors="errors"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentArticleLabels/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      contentArticleLabel: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/content-article-labels/' + this.$route.params.contentArticleLabelId).then(response => {
        this.contentArticleLabel = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-article-labels/' + this.$route.params.contentArticleLabelId, data)
          .then(response => {
            notify.success('The content article label was saved')

            this.contentArticleLabel = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
